module.exports = __webpack_public_path__ + "static/media/iitmadras.a5ed87f0.png";